import { ClientPortfolioDomainEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getPortfolioTitle } from "web_myplann/Portfolio/Components/PortfolioSections/portfolioListItemHelpers";
import { EditServicesForm } from "web_myplann/Portfolio/Pages/ServicesEdit/EditServicesForm";
import { PortfolioEditLayout } from "web_myplann/Portfolio/PortfolioShared/PortfolioEditLayout";

export const EditServicesPage = () => {
	const { t } = useResource();

	return (
		<PortfolioEditLayout
			expectedDomain={ClientPortfolioDomainEnum.Services}
			title={(portfolio) =>
				t(Resources.Portfolio.EditPortfolio.title, {
					type: getPortfolioTitle(portfolio, t),
				})
			}
		>
			{({ portfolio, portfolioId, detailRoute }) => (
				<EditServicesForm
					portfolioId={portfolioId}
					portfolio={portfolio}
					detailRoute={detailRoute}
				/>
			)}
		</PortfolioEditLayout>
	);
};
